export default __webpack_public_path__ + "static/media/contactMail.f65e7d8d.svg";